import { useState, useContext, useEffect } from "react";
import { AppContext } from "../../AppContext";

const Suvichar = () => {
  const { suvichar } = useContext(AppContext);

  // Get today's date in YYYY-MM-DD format (local time)
  const today = new Date().toLocaleDateString("en-CA"); // "2025-07-10"

  const [todaySuvichars, setTodaySuvichars] = useState([]);

  useEffect(() => {
    // Filter the suvichar items based on today's date
    const filteredSuvichars = suvichar?.filter((item) => item.date === today);
    // Sort the suvichars by updated_at, descending (latest first)
    const sortedSuvichars = filteredSuvichars?.sort(
      (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
    );

    setTodaySuvichars(sortedSuvichars || []);
  }, [today, suvichar]);

  return (
    <div className="container my-3">
      <div className="row">
        <div className="col-md-12">
          <div className="breaking-news-bar">
            <div className="label">सुविचार</div>
            <div className="divider"></div>
            <marquee
              behavior="scroll"
              direction="left"
              scrollAmount="6"
              className="text"
            >
              {todaySuvichars.length > 0 &&
                todaySuvichars.map((item, index) =>
                  item.flink ? (
                    <a
                      key={item.id || index}
                      href={item.flink}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        marginRight: "50px",
                        color: "inherit",
                        textDecoration: "none",
                      }}
                    >
                      {item.suvichar}
                    </a>
                  ) : (
                    <span
                      key={item.id || index}
                      style={{ marginRight: "50px" }}
                    >
                      {item.suvichar}
                    </span>
                  )
                )}
            </marquee>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Suvichar;
